export default{
  install(Vue,options) {
    Vue.prototype.NoticeUtils = function (response) {
      if(response.data.code == '1'){
        this.$Notice.success({
          title: "通知提醒",
          desc: response.data.message

        });
      }else if(response.data.code == '0'){
        this.$Notice.warning({
          title: "通知提醒",
          desc: response.data.message
        });
      }else{
        this.$Notice.error({
          title: "通知提醒",
          desc: response.data.message
        });
      }
    },
      Vue.prototype.NoticeUtils1 = function (response) {
        if(response.data.code == '1'){
          this.$Notice.success({
            title: "通知提醒",
            desc: response.data.message

          });
        }else if(response.data.code == '0'){
          this.$Notice.warning({
            title: "通知提醒",
            duration:0,
            desc: response.data.message
          });
        }else{
          this.$Notice.error({
            title: "通知提醒",
            duration:0,
            desc: response.data.message
          });
        }
      }
  }
}



// WEBPACK FOOTER //
// ./src/utils/NoticeUtils.js